import axios from "axios";
import Config from "src/config";

const v2_actionEditarCredenciais = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.url_prod}/api/v2/credenciais/${id}/editar`,
        data
    });
};

export default v2_actionEditarCredenciais;
